import DesktopColumns from "./DesktopColumns"

export default DesktopColumns